import React from "react";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";
import { useSelector, useDispatch } from "react-redux";
import { IConveyorBoxUI } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import useVerifyItemsA2 from "../../../hooks/useVerifyItems/useVerifyItemsA2";

type Props = {};

const ConfirmBoxButton = (props: Props) => {
  const conveyorBoxReview = useSelector<any, IConveyorBoxUI>(
    (state) => state.conveyorBoxReviewReducer
  );

  const items = conveyorBoxReview.items.active;
  const { onSetBoxAsControlledHandler } = useConveyorBoxHandlers();

  const { isAllItemsVerified } = useVerifyItemsA2({
    items,
  });

  return (
    <>
      <Button
        style={{ gridColumn: "1 / -1" }}
        content="OK"
        size="big"
        color="green"
        aria-label="OK"
        icon="check"
        onClick={onSetBoxAsControlledHandler}
        disabled={!isAllItemsVerified}
      />
    </>
  );
};

export default ConfirmBoxButton;
